
'use strict';

angular.module('mean.inspinia').config(['$stateProvider',
  function($stateProvider) {

    $stateProvider.state('inspinia example page', {
      url: '/inspinia/example',
      templateUrl: 'inspinia/views/index.html'
    });
  }
]);

angular.module('mean.inspinia')
  .run(['$rootScope', function($rootScope) {
    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
      var toPath = toState.url;
      toPath = toPath.replace(new RegExp('/', 'g'), '');
      toPath = toPath.replace(new RegExp(':', 'g'),'-');
      toPath = toPath.split(new RegExp('[?#]'))[0];
      $rootScope.state = toPath;
      if($rootScope.state === '' ) {
        $rootScope.state = 'firstPage';
      }
    });
  }]);

angular.module('mean.inspinia', ['mean.system'])
  .config(['$viewPathProvider', function($viewPathProvider) {
    console.log('In the override section');
    // $viewPathProvider.override('system/views/index.html', 'inspinia/server/views/index.html');
    // $viewPathProvider.override('users/views/login.html', 'inspinia/server/views/login.html');
    // $viewPathProvider.override('users/views/index.html', 'inspinia/server/views/or.html');
    // $viewPathProvider.override('users/views/forgot-password.html', 'inspinia/server/views/forgot-password.html');
    //$viewPathProvider.override('users/views/register.html', 'inspinia/views/register.html');
  }]);



// WEBPACK FOOTER //
// ./packages/custom/inspinia/public/routes/inspinia.js